import { createContext, useState } from "react";
const defaultValue = ["dark", "light"];

const ADMIN_SESSION_KEY = "ndAdminSession";
const ADMIN_SESSION_TTL_MS = 12 * 60 * 60 * 1000; // 12 hours

const USER_SESSION_KEY = "Db456";
const LANGUAGE_KEY = "ndLanguageIsEnglish";

const readLanguagePreference = () => {
  try {
    const raw = localStorage.getItem(LANGUAGE_KEY);
    return raw === null ? true : raw === "true";
  } catch (e) {
    return true;
  }
};

const readUserSession = () => {
  try {
    const raw = localStorage.getItem(USER_SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

const readAdminSession = () => {
  try {
    const raw = localStorage.getItem(ADMIN_SESSION_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    if (parsed?.expiresAt && parsed.expiresAt > Date.now()) return true;
    localStorage.removeItem(ADMIN_SESSION_KEY);
    return false;
  } catch (e) {
    return false;
  }
};

export const ThemeContext = createContext({
  mode: defaultValue,
  isDarkMode: true | false,
  toggleTheme: () => {},
  toggleLangauge: () => {},
  isLanguageEnglish: true | false,
  globalLoading: true | false,
  toggleGlobalLoading: () => {},
  updateUserData: () => {},
  userData: {},
  configs: {},
  setConfigs: () => {},
  currentYear: new Date().getFullYear(),
  setCurrentYear: () => {},
  isAdminAuthed: false,
  adminLogin: () => {},
  adminLogout: () => {},
});

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [isEnglish, setIsEnglish] = useState(readLanguagePreference);
  const [configs, setConfigs] = useState({});
  const [globalLoading, setGlobalLoading] = useState(false);
  const [userData, setUserData] = useState(readUserSession);
  const [isAdminAuthed, setIsAdminAuthed] = useState(readAdminSession());

  const adminLogin = () => {
    localStorage.setItem(
      ADMIN_SESSION_KEY,
      JSON.stringify({ expiresAt: Date.now() + ADMIN_SESSION_TTL_MS })
    );
    setIsAdminAuthed(true);
  };

  const adminLogout = () => {
    localStorage.removeItem(ADMIN_SESSION_KEY);
    setIsAdminAuthed(false);
  };

  const value = {
    mode: isDarkMode ? "dark" : "light",
    isDarkMode,
    isLanguageEnglish: isEnglish,
    toggleTheme: () => setIsDarkMode((mode) => !mode),
    toggleLangauge: () =>
      setIsEnglish((language) => {
        const next = !language;
        try {
          localStorage.setItem(LANGUAGE_KEY, String(next));
        } catch (e) {
          // ignore storage errors
        }
        return next;
      }),
    globalLoading,
    toggleGlobalLoading: (state) => setGlobalLoading(state),
    updateUserData: (paylaod) => setUserData(paylaod),
    userData,
    configs,
    setConfigs,
    currentYear,
    setCurrentYear,
    isAdminAuthed,
    adminLogin,
    adminLogout,
  };
  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};
